/* <td-booster-buybox-builder> — each checked booster set resolves to ONE pre-made
   product (combo JSON); its variant (+ Recharge plan on sub) drives the <product-form>. */
if (!customElements.get('td-booster-buybox-builder')) {
  class TdBoosterBuyboxBuilder extends HTMLElement {
    connectedCallback() {
      this.combos = this.parseCombos();
      this.checkboxes = Array.from(this.querySelectorAll('.td-bbb__check-input'));
      this.form = this.querySelector('form[data-type="add-to-cart-form"]') || this.querySelector('.product-form form');
      this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
      this.subRadio = this.querySelector('.td-lpcp__toggle-input[value="subscription"]');
      this.onetimeRadio = this.querySelector('.td-lpcp__toggle-input[value="onetime"]');
      this.subToggleLabel = this.querySelector('.td-lpcp__toggle-button--subscription');
      this.basePriceEl = this.querySelector('.td-bbb__base-price');
      this.atcPriceEl = this.querySelector('[data-atc-price]');
      this.atcCompareEl = this.querySelector('[data-atc-compare-price]');
      this.atcButton = this.querySelector('.td-bbb__atc-button');
      this.boosterContainer = this.querySelector('.td-bbb__preview-boosters');

      this.stackEl = this.querySelector('[data-bbb-stack]');
      if (this.stackEl) {
        this.stackToggle = this.stackEl.querySelector('[data-stack-toggle]');
        this.stackCount = this.stackEl.querySelector('[data-stack-count]');
        this.stackToggleText = this.stackEl.querySelector('[data-stack-toggletext]');
        this.stackWas = this.stackEl.querySelector('[data-stack-was]');
        this.stackNow = this.stackEl.querySelector('[data-stack-now]');
        this.stackPermo = this.stackEl.querySelector('[data-stack-permo]');
        this.stackBadge = this.stackEl.querySelector('[data-stack-badge]');
        this.stackList = this.stackEl.querySelector('[data-stack-list]');
        this.baseTitle = this.stackEl.getAttribute('data-base-title') || '';
        this.baseLabel = this.stackEl.getAttribute('data-base-label') || '';
        this.basePrice = this.stackEl.getAttribute('data-base-price') || '';
        this.stackShowText = this.stackEl.getAttribute('data-show-text') || "What's included";
        this.stackHideText = this.stackEl.getAttribute('data-hide-text') || 'Hide details';
        this.stackBadgeText = this.stackEl.getAttribute('data-badge-text') || 'Subscribe & Save';
        this.stackDiscountLabel = this.stackEl.getAttribute('data-discount-label') || 'Stack discount';
        if (this.stackToggle) this.stackToggle.addEventListener('click', () => this.toggleStack());
      }

      this.checkboxes.forEach((cb) => cb.addEventListener('change', () => {
        this.resolve();
        this.goToFirstSlide();
      }));
      if (this.subRadio) this.subRadio.addEventListener('change', () => this.onPlanChange());
      if (this.onetimeRadio) this.onetimeRadio.addEventListener('change', () => this.onPlanChange());

      this.resolve();
    }

    parseCombos() {
      const el = this.querySelector('.td-bbb__combos');
      let raw = [];
      if (el) {
        try { raw = JSON.parse(el.textContent.trim()); } catch (e) { raw = []; }
      }
      return raw.map((c) => Object.assign({}, c, {
        keys: String(c.boosterKeys || '').split(',').map((s) => s.trim()).filter(Boolean).sort(),
      }));
    }

    checkedKeys() {
      return this.checkboxes
        .filter((cb) => cb.checked)
        .map((cb) => cb.getAttribute('data-booster-key'))
        .sort();
    }

    sameSet(a, b) {
      return a.length === b.length && a.every((k, i) => k === b[i]);
    }

    findCombo(keys) {
      return this.combos.find((c) => this.sameSet(c.keys, keys)) || null;
    }

    isSub() {
      return this.subRadio ? this.subRadio.checked : false;
    }

    onPlanChange() {
      if (!this.currentCombo) return;
      this.applyPlan(this.currentCombo);
      this.updatePrice(this.currentCombo);
      this.updateBasePrice();
      this.updateCardPrices();
      this.updateStack(this.currentCombo);
    }

    resolve() {
      const keys = this.checkedKeys();
      const combo = this.findCombo(keys);
      this.currentCombo = combo;

      if (combo) {
        if (this.idInput) this.idInput.value = combo.variantId;
        this.applySubAvailability(combo);
        this.applyPlan(combo);
        this.updatePrice(combo);
        this.updatePlanPrices(combo);
        this.setAtcDisabled(false);
      } else {
        this.setAtcDisabled(true);
      }

      this.updateDisabledCheckboxes(keys);
      this.updateActiveStyles();
      this.updateGallery();
      this.updateBasePrice();
      this.updateCardPrices();
      this.updateStack(combo);
    }

    // No Recharge plan -> hide Subscription, force One-Time.
    applySubAvailability(combo) {
      if (this.subToggleLabel) this.subToggleLabel.style.display = combo.hasSub ? '' : 'none';
      if (!combo.hasSub && this.onetimeRadio && !this.onetimeRadio.checked) {
        this.onetimeRadio.checked = true;
      }
    }

    // selling_plan input present only for a subscription.
    applyPlan(combo) {
      if (!this.form) return;
      let sp = this.form.querySelector('input[name="selling_plan"]');
      const wantSub = this.isSub() && combo.hasSub && combo.sellingPlanId;
      if (wantSub) {
        if (!sp) {
          sp = document.createElement('input');
          sp.type = 'hidden';
          sp.name = 'selling_plan';
          this.form.appendChild(sp);
        }
        sp.value = combo.sellingPlanId;
      } else if (sp) {
        sp.remove();
      }
    }

    updatePrice(combo) {
      const sub = this.isSub() && combo.hasSub;
      const priceMoney = sub ? combo.subMoney : combo.regMoney;
      const priceCents = sub ? combo.subCents : combo.regCents;
      const compareMoney = sub ? combo.subCompareMoney : combo.compareMoney;
      const compareCents = sub ? combo.subCompareCents : combo.compareCents;
      if (this.atcPriceEl) this.atcPriceEl.textContent = priceMoney;
      if (this.atcCompareEl) this.atcCompareEl.textContent = compareCents > priceCents ? compareMoney : '';
    }

    updatePlanPrices(combo) {
      const setText = (sel, val) => {
        const el = this.querySelector(sel);
        if (el) el.textContent = val;
      };
      const setStrike = (sel, show, val) => {
        const el = this.querySelector(sel);
        if (!el) return;
        el.textContent = show ? val : '';
        el.style.display = show ? '' : 'none';
      };

      const subDiscount = combo.hasSub && combo.regCents > combo.subCents;
      setText('[data-sub-now]', combo.subMoney);
      setStrike('[data-sub-was]', subDiscount, combo.regMoney);
      const save = this.querySelector('[data-plan-save]');
      if (save) {
        if (subDiscount) {
          const pct = Math.round(((combo.regCents - combo.subCents) / combo.regCents) * 100);
          save.textContent = 'Save ' + pct + '%';
          save.style.display = '';
        } else {
          save.textContent = '';
          save.style.display = 'none';
        }
      }

      setText('[data-otp-now]', combo.regMoney);
      setStrike('[data-otp-was]', combo.compareCents > combo.regCents, combo.compareMoney);
    }

    // Plan-aware base price so itemized rows sum to the totals.
    updateBasePrice() {
      const base = this.findCombo([]);
      if (!base) return;
      const sub = this.isSub() && base.hasSub;
      const money = sub ? base.subMoney : base.regMoney;
      if (this.basePriceEl) this.basePriceEl.textContent = money;
      this.basePrice = money;
    }

    // Formats cents using a server-rendered money string as the template.
    formatMoney(cents, sample) {
      let num = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return String(sample || '$0').replace(/[\d.,]+/, num);
    }

    // Auto card price ([data-auto-price], blank price_label) = plan-aware delta
    // (solo combo - base); syncs data-booster-price for the summary rows.
    updateCardPrices() {
      const base = this.findCombo([]);
      if (!base) return;
      this.checkboxes.forEach((cb) => {
        const card = cb.closest('.td-bbb__card');
        const el = card ? card.querySelector('[data-auto-price]') : null;
        if (!el) return;
        const solo = this.findCombo([cb.getAttribute('data-booster-key')]);
        if (!solo) {
          el.textContent = '';
          cb.removeAttribute('data-booster-price');
          return;
        }
        const sub = this.isSub() && solo.hasSub && base.hasSub;
        const cents = sub ? solo.subCents - base.subCents : solo.regCents - base.regCents;
        if (cents <= 0) {
          el.textContent = '';
          cb.removeAttribute('data-booster-price');
          return;
        }
        const money = this.formatMoney(cents, base.regMoney);
        el.textContent = '+' + money;
        cb.setAttribute('data-booster-price', money);
      });
    }

    setAtcDisabled(disabled) {
      if (!this.atcButton) return;
      this.atcButton.disabled = disabled;
      this.atcButton.classList.toggle('is-unavailable', disabled);
    }

    // Grey out a booster whose toggle would land on a set that has no product.
    updateDisabledCheckboxes(keys) {
      this.checkboxes.forEach((cb) => {
        const k = cb.getAttribute('data-booster-key');
        const next = cb.checked ? keys.filter((x) => x !== k) : keys.concat(k).sort();
        const ok = !!this.findCombo(next);
        cb.disabled = !ok;
        const card = cb.closest('.td-bbb__card');
        if (card) card.classList.toggle('is-disabled', !ok);
      });
    }

    updateActiveStyles() {
      this.checkboxes.forEach((cb) => {
        const card = cb.closest('.td-bbb__card');
        if (card) card.classList.toggle('td-active', cb.checked);
      });
    }

    goToFirstSlide() {
      const main = this.querySelector('[data-swiper]:not([data-swiper-thumbs])');
      if (main && main.swiper) main.swiper.slideTo(0);
    }

    updateGallery() {
      if (!this.boosterContainer) return;
      this.boosterContainer.textContent = '';
      this.checkboxes.filter((cb) => cb.checked).forEach((cb) => {
        const src = cb.getAttribute('data-booster-image');
        if (!src) return;
        const plus = document.createElement('span');
        plus.className = 'td-bbb__preview-plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        const img = document.createElement('img');
        img.className = 'td-bbb__preview-booster';
        img.src = src;
        img.alt = '';
        this.boosterContainer.appendChild(plus);
        this.boosterContainer.appendChild(img);
      });
    }

    toggleStack() {
      if (!this.stackToggle) return;
      const open = this.stackToggle.getAttribute('aria-expanded') === 'true';
      this.stackToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (this.stackList) this.stackList.hidden = open;
      if (this.stackToggleText) this.stackToggleText.textContent = open ? this.stackShowText : this.stackHideText;
    }

    updateStack(combo) {
      if (!this.stackEl || !combo) return;
      const count = 1 + this.checkedKeys().length;
      if (this.stackCount) this.stackCount.textContent = count + (count === 1 ? ' item' : ' items');

      const sub = this.isSub() && combo.hasSub;
      const nowMoney = sub ? combo.subMoney : combo.regMoney;
      const nowCents = sub ? combo.subCents : combo.regCents;
      const wasMoney = sub ? combo.subCompareMoney : combo.compareMoney;
      const wasCents = sub ? combo.subCompareCents : combo.compareCents;

      if (this.stackNow) this.stackNow.textContent = nowMoney;
      if (this.stackWas) {
        const show = wasCents > nowCents;
        this.stackWas.textContent = show ? wasMoney : '';
        this.stackWas.style.display = show ? '' : 'none';
      }
      if (this.stackPermo) this.stackPermo.style.display = sub ? '' : 'none';

      let pct = 0;
      if (sub && wasCents > nowCents) pct = Math.round(((wasCents - nowCents) / wasCents) * 100);
      if (this.stackBadge) {
        if (sub && pct > 0) {
          this.stackBadge.textContent = this.stackBadgeText + ' ' + pct + '% applied';
          this.stackBadge.style.display = '';
        } else {
          this.stackBadge.textContent = '';
          this.stackBadge.style.display = 'none';
        }
      }
      this.renderStackList(combo, sub);
    }

    parseCents(money) {
      return Math.round(parseFloat(String(money).replace(/[^0-9.]/g, '')) * 100) || 0;
    }

    renderStackList(combo, sub) {
      if (!this.stackList) return;
      this.stackList.textContent = '';
      const addRow = (name, label, labelColor, price, isSave) => {
        const r = document.createElement('div');
        r.className = 'td-bbb__stack-row' + (isSave ? ' td-bbb__stack-row--save' : '');
        const left = document.createElement('span');
        left.className = 'td-bbb__stack-row-left';
        const n = document.createElement('span');
        n.className = 'td-bbb__stack-row-name';
        n.textContent = name;
        left.appendChild(n);
        if (label) {
          const l = document.createElement('span');
          l.className = 'td-bbb__stack-row-label';
          if (labelColor) l.style.color = labelColor;
          l.textContent = label;
          left.appendChild(l);
        }
        const p = document.createElement('span');
        p.className = 'td-bbb__stack-row-price';
        p.textContent = price;
        r.appendChild(left);
        r.appendChild(p);
        this.stackList.appendChild(r);
      };

      addRow(this.baseTitle, this.baseLabel, '', this.basePrice, false);
      let rowSum = this.parseCents(this.basePrice);
      this.checkboxes.filter((cb) => cb.checked).forEach((cb) => {
        const name = cb.getAttribute('data-booster-name') || '';
        const cat = cb.getAttribute('data-booster-cat') || '';
        const accent = cb.getAttribute('data-booster-accent') || '';
        const price = (cb.getAttribute('data-booster-price') || '').replace(/^\+\s*/, '');
        rowSum += this.parseCents(price);
        addRow(name, cat, accent, price, false);
      });
      // A multi-booster combo can be cheaper than its parts; the discount row
      // closes that gap so rows always sum to the total.
      if (combo) {
        const totalCents = sub ? combo.subCents : combo.regCents;
        const discount = rowSum - totalCents;
        if (discount > 0) {
          addRow(this.stackDiscountLabel, '', '', '−' + this.formatMoney(discount, combo.regMoney), true);
        }
      }
    }
  }
  customElements.define('td-booster-buybox-builder', TdBoosterBuyboxBuilder);
}
